export function propValue(obj) {
    return typeof obj === 'function' ? obj() : obj;
}

export function hasProperty(obj, properties) {
    var ret = true,
        currentObj = obj,
        props = properties.split('.'),
        i = 0,
        l = props.length;

    for (; i < l; i++) {
        if (!currentObj || typeof currentObj[props[i]] === 'undefined') {
            ret = false;
            break;
        }

        currentObj = propValue(currentObj[props[i]]);
    }

    return ret;
}

export function prop(name) {
    return function(item) {
        return propValue(item[name]);
    };
}

export function propEquals(propName, value) {
    return function(obj) {
        return propValue(obj[propName]) === value;
    };
}

export function propDoesNotEqual(propName, value) {
    return function(obj) {
        return propValue(obj[propName]) !== value;
    };
}

export function keyMatches(obj, key) {
    return function(obj2) {
        return obj[key] === obj2[key];
    };
}

export function keyValueMatchCount(obj1, obj2) {
    if (!obj1) {
        return -1;
    }

    var matches = 0,
        key;

    for (key in obj1) {
        if (Object.keys(obj2).indexOf(key) > -1) {
            if (propValue(obj1[key]) !== propValue(obj2[key])) {
                continue;
            }
            matches++;
        }
    }

    return matches;
}

export function contains(searchObject, findObject) {
    if (!searchObject) {
        return false;
    }

    var matches = keyValueMatchCount(searchObject, findObject);

    return Object.keys(findObject).length === matches;
}   

export function equals(searchObject, findObject) {
    return JSON.stringify(searchObject) === JSON.stringify(findObject);
}

export function setKeyValue(object, key, value) {
    if (!value && key in object) {
        delete object[key];
    } else {
        object[key] = value;
    }

    return object;
}

export function copy(obj) {
    return Object.assign ? Object.assign({}, obj) : Object.keys(obj).reduce(function(o, key) {
        o[key] = obj[key];
        return o;
    }, {});
}
